// src/components/nearby-airport-suggestion/nearby-airport-suggestion.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSExpandoListItemFragment on EGDSExpandoListItem {\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expandedLabel\n    expanded\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSExpandoCardFragment on EGDSExpandoCard {\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expandedLabel\n    expanded\n    subtitle\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {\n    expandedLabel\n    collapsedLabel\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expanded\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    action {\n      accessibility\n      target\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    icon {\n      id\n    }\n    iconPosition\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PackageUINearbyAirportsFragment on PackageUINearbyAirports {\n    primary\n    airports {\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  query SharedUINearbyAirportSuggestionQuery($context: ContextInput!, $sessionId: String!) {\n    nearbyAirportsSuggestion(context: $context, sessionId: $sessionId) {\n      expando {\n        ...EGDSExpandoCardFragment\n      }\n      content {\n        ...PackageUINearbyAirportsFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React6 from "react";
import { gql as gql6, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/egds-expando/egds-expando-list-item.tsx
import React, { useState } from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoListItem } from "uitk-react-expando";
var fragment = gql(_templateObject());
var EGDSExpandoListItem = function(param) {
    var _param_data = param.data, expandAnalytics = _param_data.expandAnalytics, expandedLabel = _param_data.expandedLabel, collapseAnalytics = _param_data.collapseAnalytics, collapsedLabel = _param_data.collapsedLabel, expanded = _param_data.expanded, content = param.content, ExpandoTitle = param.ExpandoTitle;
    var clickTracker = useClickTracker();
    var _useState = _slicedToArray(useState(expanded), 2), visible = _useState[0], setVisible = _useState[1];
    var _useState1 = _slicedToArray(useState(expanded ? expandedLabel : collapsedLabel), 2), label = _useState1[0], setLabel = _useState1[1];
    var onToggle = function() {
        if (visible) {
            setLabel(collapsedLabel);
            if (collapseAnalytics) {
                clickTracker(collapseAnalytics.referrerId, collapseAnalytics.linkName);
            }
        } else {
            setLabel(expandedLabel);
            if (expandAnalytics) {
                clickTracker(expandAnalytics.referrerId, expandAnalytics.linkName);
            }
        }
        setVisible(function(isVisible) {
            return !isVisible;
        });
    };
    var expandoTitle = ExpandoTitle ? /* @__PURE__ */ React.createElement(ExpandoTitle, null, label) : label;
    return /* @__PURE__ */ React.createElement(UitkExpandoListItem, {
        isVisible: visible,
        expandoTitle: expandoTitle,
        expandoDescription: content,
        onToggle: onToggle
    });
};
EGDSExpandoListItem.fragment = fragment;
EGDSExpandoListItem.displayName = "EGDSExpandoListItem";
// ../internal/src/components/egds-expando/egds-expando-card.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment2 = gql2(_templateObject1());
var EGDSExpandoCard = function(param) {
    var data = param.data, children = param.children;
    var expandAnalytics = data.expandAnalytics, expandedLabel = data.expandedLabel, collapseAnalytics = data.collapseAnalytics, collapsedLabel = data.collapsedLabel, expanded = data.expanded, subtitle = data.subtitle;
    var clickTracker = useClickTracker2();
    var _React2_useState = _slicedToArray(React2.useState(expanded), 2), isVisible = _React2_useState[0], setIsVisible = _React2_useState[1];
    var _React2_useState1 = _slicedToArray(React2.useState(expanded ? expandedLabel : collapsedLabel), 2), label = _React2_useState1[0], setLabel = _React2_useState1[1];
    var expandoSubtitle = subtitle !== null && subtitle !== void 0 ? subtitle : void 0;
    var handleClick = React2.useCallback(function() {
        if (isVisible) {
            setLabel(collapsedLabel);
            collapseAnalytics && clickTracker(collapseAnalytics.referrerId, collapseAnalytics.linkName);
        } else {
            setLabel(expandedLabel);
            expandAnalytics && clickTracker(expandAnalytics.referrerId, expandAnalytics.linkName);
        }
        setIsVisible(!isVisible);
    }, [
        isVisible,
        clickTracker,
        expandedLabel,
        collapsedLabel,
        collapseAnalytics,
        expandAnalytics
    ]);
    return /* @__PURE__ */ React2.createElement(UitkCard, null, /* @__PURE__ */ React2.createElement(UitkCardContentSection, {
        padded: true
    }, /* @__PURE__ */ React2.createElement(UitkCardLink, null, /* @__PURE__ */ React2.createElement("button", {
        type: "button",
        onClick: handleClick
    })), /* @__PURE__ */ React2.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React2.createElement(UitkText, {
        size: 400,
        weight: "bold",
        theme: "default"
    }, label), expandoSubtitle), /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, {
        alignSelf: "center",
        grow: 0
    }, /* @__PURE__ */ React2.createElement(UitkCardContentSection, {
        padded: false
    }, isVisible ? /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: "expand_less",
        size: UitkIconSize.SMALL
    }) : /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: "expand_more",
        size: UitkIconSize.SMALL
    }))))), isVisible && /* @__PURE__ */ React2.createElement(UitkCardContentSection, {
        "data-stid": "uitk-expando-card-content",
        padded: [
            "blockend",
            "inlinestart",
            "inlineend"
        ]
    }, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockend: "one",
            inline: "one"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, children))));
};
EGDSExpandoCard.fragment = fragment2;
EGDSExpandoCard.displayName = "EGDSExpandoCard";
// ../internal/src/components/egds-expando/egds-expando-peek.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek } from "uitk-react-expando";
var fragment3 = gql3(_templateObject2());
var EGDSExpandoPeek = function(param) {
    var className = param.className, lines = param.lines, items = param.items, data = param.data, children = param.children;
    var expandAnalytics = data.expandAnalytics, collapseAnalytics = data.collapseAnalytics, expandedLabel = data.expandedLabel, collapsedLabel = data.collapsedLabel, expanded = data.expanded;
    var _React3_useState = _slicedToArray(React3.useState(expanded), 2), isVisible = _React3_useState[0], setIsVisible = _React3_useState[1];
    var handleClick = React3.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible,
        setIsVisible
    ]);
    var clickTracker = useClickTracker3();
    var _expandAnalytics_referrerId, _expandAnalytics_linkName;
    var expandoExpandAnalytics = {
        id: (_expandAnalytics_referrerId = expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.referrerId) !== null && _expandAnalytics_referrerId !== void 0 ? _expandAnalytics_referrerId : "",
        description: (_expandAnalytics_linkName = expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.linkName) !== null && _expandAnalytics_linkName !== void 0 ? _expandAnalytics_linkName : "",
        callback: React3.useCallback(function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }, [
            clickTracker
        ])
    };
    var _collapseAnalytics_referrerId, _collapseAnalytics_linkName;
    var expandoCollapseAnalytics = {
        id: (_collapseAnalytics_referrerId = collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.referrerId) !== null && _collapseAnalytics_referrerId !== void 0 ? _collapseAnalytics_referrerId : "",
        description: (_collapseAnalytics_linkName = collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.linkName) !== null && _collapseAnalytics_linkName !== void 0 ? _collapseAnalytics_linkName : "",
        callback: React3.useCallback(function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }, [
            clickTracker
        ])
    };
    return /* @__PURE__ */ React3.createElement(UitkExpandoPeek, {
        isVisible: isVisible,
        items: items,
        lines: lines,
        expandLabel: collapsedLabel !== null && collapsedLabel !== void 0 ? collapsedLabel : "",
        collapseLabel: expandedLabel !== null && expandedLabel !== void 0 ? expandedLabel : "",
        handleClick: handleClick,
        className: className,
        analytics: isVisible ? expandoCollapseAnalytics : expandoExpandAnalytics
    }, children);
};
EGDSExpandoPeek.fragment = fragment3;
EGDSExpandoPeek.displayName = "EGDSExpandoPeek";
// src/components/nearby-airport-suggestion/__private/package-ui-nearby-airports.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/egds-link/egds-standard-link.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment4 = gql4(_templateObject3());
var _obj;
var UILinkTargetMap = (_obj = {}, _defineProperty(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank" /* EXTERNAL */ ), _defineProperty(_obj, "INTERNAL" /* INTERNAL */ , "_self" /* INTERNAL */ ), _obj);
var EGDSStandardLink = function(param) {
    var data = param.data, inline = param.inline, iconSize = param.iconSize;
    var action = data.action, text = data.text, icon = data.icon, iconPosition = data.iconPosition;
    var analytics = action.analytics, resource = action.resource, target = action.target, accessibility = action.accessibility;
    var clickTracker = useClickTracker4();
    var onClick = React4.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React4.createElement(UitkLink, {
        onClickCapture: onClick,
        inline: inline !== null && inline !== void 0 ? inline : true
    }, /* @__PURE__ */ React4.createElement("a", {
        target: UILinkTargetMap[target],
        href: resource.value
    }, icon && iconPosition !== "TRAILING" /* TRAILING */  && /* @__PURE__ */ React4.createElement(UitkIcon2, {
        name: icon.id,
        size: iconSize
    }), text, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React4.createElement(UitkIcon2, {
        name: icon.id,
        size: iconSize
    }), accessibility && /* @__PURE__ */ React4.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.displayName = "EGDSStandardLink";
EGDSStandardLink.fragment = fragment4;
// src/components/nearby-airport-suggestion/__private/package-ui-nearby-airports.tsx
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment5 = gql5(_templateObject4(), EGDSStandardLink.fragment);
var PackageUINearbyAirports = function(param) {
    var _param_data = param.data, primary = _param_data.primary, airports = _param_data.airports;
    return /* @__PURE__ */ React5.createElement(UitkText3, {
        size: 300,
        spacing: "two",
        theme: "default"
    }, primary, /* @__PURE__ */ React5.createElement(UitkList, {
        bullet: "no-bullet",
        spacing: true
    }, airports.map(function(item, index) {
        return /* @__PURE__ */ React5.createElement(UitkListItem, {
            key: "egds-link-list-".concat(index)
        }, /* @__PURE__ */ React5.createElement(EGDSStandardLink, {
            data: item
        }));
    })));
};
PackageUINearbyAirports.fragment = fragment5;
PackageUINearbyAirports.displayName = "PackageUINearbyAirports";
// src/components/nearby-airport-suggestion/nearby-airport-suggestion.tsx
var __Query = gql6(_templateObject5(), EGDSExpandoCard.fragment, PackageUINearbyAirports.fragment);
var NearbyAirportSuggestion = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, LoadingPlaceholder = props.loadingPlaceholder;
    var context = useBexApi().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return LoadingPlaceholder ? /* @__PURE__ */ React6.createElement(LoadingPlaceholder, null) : null;
    }
    if (error || !data || !data.nearbyAirportsSuggestion) {
        return null;
    }
    var _data_nearbyAirportsSuggestion = data.nearbyAirportsSuggestion, expando = _data_nearbyAirportsSuggestion.expando, content = _data_nearbyAirportsSuggestion.content;
    return /* @__PURE__ */ React6.createElement(EGDSExpandoCard, {
        data: expando
    }, /* @__PURE__ */ React6.createElement(PackageUINearbyAirports, {
        data: content
    }));
};
NearbyAirportSuggestion.displayName = "NearbyAirportSuggestion";
export { NearbyAirportSuggestion };
//# sourceMappingURL=index.js.map